import { Controller } from "@hotwired/stimulus"

// Email composer on the shared inbox thread page. Submits the compose form
// over fetch (JSON) so the thread can report success/failure inline and
// reload, instead of a full navigation. Ported from an inline <script> that
// hand-registered onto the global Stimulus instance — moving it into the
// registry removes the fragile inline registration the audit flagged.
export default class extends Controller {
  static targets = ["submitBtn", "status"]

  submit(event) {
    event.preventDefault()
    const form = event.target
    const formData = new FormData(form)

    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "Sending..."

    fetch(form.action, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "Accept": "application/json"
      }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          this.statusTarget.className = "p-3 bg-[#9CAF88]/20 text-[#9CAF88] rounded-lg text-sm"
          this.statusTarget.textContent = "Email sent successfully! Reloading..."
          this.statusTarget.classList.remove("hidden")
          setTimeout(() => window.location.reload(), 1500)
        } else {
          this.statusTarget.className = "p-3 bg-[#E57373]/20 text-[#E57373] rounded-lg text-sm"
          this.statusTarget.textContent = data.message || "Failed to send email."
          this.statusTarget.classList.remove("hidden")
          this.submitBtnTarget.disabled = false
          this.submitBtnTarget.textContent = "Send Email"
        }
      })
      .catch(() => {
        this.statusTarget.className = "p-3 bg-[#E57373]/20 text-[#E57373] rounded-lg text-sm"
        this.statusTarget.textContent = "Network error. Please try again."
        this.statusTarget.classList.remove("hidden")
        this.submitBtnTarget.disabled = false
        this.submitBtnTarget.textContent = "Send Email"
      })
  }
}
